export default __webpack_public_path__ + "alberta-high-flow.c58b3fdaed7565b84a79.svg";